import { Component } from '@angular/core';
import { header } from './config/clinic.config';
import { ClinicService } from '../../services/clinic/clinic.service';

@Component({
  selector: 'app-clinic',
  templateUrl: './clinic.component.html',
  styleUrl: './clinic.component.scss'
})
export class ClinicComponent {
  constructor(private clinicService: ClinicService) {}

  ngOnInit() {
    this.clinicService.init();
  }

  getPageHeader(): string {
    return header;
  }
}
